export default __webpack_public_path__ + "static/media/trek.86e028f0.png";